module.exports = __webpack_public_path__ + "./images/8ca9f23d97d0260b4852ecb00f3e8579.webp";